var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99974 0.291992C6.1655 0.291992 6.32447 0.35784 6.44168 0.47505L11.5 5.53338C11.7441 5.77746 11.7441 6.17319 11.5 6.41727C11.2559 6.66134 10.8602 6.66134 10.6161 6.41727L5.99974 1.80088L1.38335 6.41727C1.13927 6.66134 0.743542 6.66134 0.499464 6.41727C0.255387 6.17319 0.255387 5.77746 0.499465 5.53338L5.5578 0.47505C5.67501 0.35784 5.83398 0.291992 5.99974 0.291992Z",
    fill: "#0B0C0E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 0.433594C6.34518 0.433594 6.625 0.713416 6.625 1.05859V15.0836C6.625 15.4288 6.34518 15.7086 6 15.7086C5.65482 15.7086 5.375 15.4288 5.375 15.0836V1.05859C5.375 0.713416 5.65482 0.433594 6 0.433594Z",
    fill: "#0B0C0E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowTop);
export default __webpack_public_path__ + "static/media/arrowTop.b25fa0cf9cc4afe62d7950ffaf1cf504.svg";
export { ForwardRef as ReactComponent };